import { render } from "./OrderItemModal.vue?vue&type=template&id=4a61e34c"
import script from "./OrderItemModal.vue?vue&type=script&lang=js"
export * from "./OrderItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__